 
document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('catalogueRequestForm');
    const submitMsg = document.querySelector('.submit-msg');
     const submitButton = form.querySelector('#catalogueRequestForm button[type="submit"]'); // Select the submit button

    form.addEventListener('submit', async function (e) {
        e.preventDefault(); // Prevent default form submission
       submitButton.disabled = true;
        const originalButtonText = submitButton.innerHTML;
        submitButton.innerHTML = '<span class="loader"></span> Sending...'; // Add loader text
        // Gather form data
        const formData = new FormData(form);
        const data = {};
        formData.forEach((value, key) => {
            data[key] = value;
        });

        try {
            // Send data to the backend server
            const response = await fetch('https://spiral-catalogue-105bd8e1bc3b.herokuapp.com/create-order', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });

            const result = await response.json();

            if (response.ok) {
                // Success message
                submitMsg.textContent = 'Your catalogue request has been submitted successfully!';
                submitMsg.style.display = 'block';
                form.reset();
            } else {
                // Handle errors
                submitMsg.textContent = result.error || 'An error occurred. Please try again.';
                submitMsg.style.color = 'red';
                submitMsg.style.display = 'block';
            }
        } catch (error) {
            console.error('Error:', error);
            submitMsg.textContent = 'An unexpected error occurred. Please try again later.';
            submitMsg.style.color = 'red';
            submitMsg.style.display = 'block';
        } finally {
            // Re-enable the submit button and restore original text
            submitButton.disabled = false;
            submitButton.innerHTML = originalButtonText;
        }
    });
});
 
